export class StepsCategoryModel {
  categories: CategoryModel[];
  isExtra: boolean;
}

export class CategoryModel {
  categoryTitle: string;
  activities: ActivitiesStep[];
  order: number;
}

export class ActivitiesStep {
  id: string;
  title: string;
  style: string;
  isHidden: boolean;
  link: string | null;
  typologyTitle?: string;
  typologyStyle?: string;
  solutionaryLink?: string;
  typologyName: string;
  disabled?: boolean;
  completedExcercises?: number;
  totalExcercises?: number;
  isSent?: boolean;
}

export class ActivitiesExtraStep {
  id: string;
  typologyTitle?: string;
  typologyName?: string;
  title?: string;
  typologyStyle?: string;
  isHidden?: boolean;
  link?: string | null;
}

export class StepBlock {
  id?: string;
  title?: string;
  style?: string;
  order?: number;
  steps?: StepZero[];
  open?: boolean;
  content?: StepsExtraBlock[];
}

export class StepsExtraBlock {
  id?: string;
  title?: string;
  order?: number;
  style?: string;
  activities?: ActivitiesExtraStep[];
}

export class StepZero {
  stepId?: string;
  title?: string;
  order?: number;
  dropdown?: boolean;
  period?: number;
  isInItinerary: boolean;
}

export class StepParent {
  category?: string;
  activities?: StepActivity[];
  order?: number;
}

export class StepActivity {
  id?: string;
  title?: string;
  style?: string;
  typologyStyle?: string;
  typologyName?: string;
  isHidden?: boolean;
  link?: string;
  resourceUrl?: string;
  categoryName?: string;
  solutionaryUrl?: string;
  solutionaryLink?: string;
  disabled?: boolean;
  totalExcercises?: number;
  completedExcercises?: number;
  isSent?: boolean;
}
